// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"_33-QC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Wrappers/DurationWrapper/DurationWrapper.scss
// module id = 508
// module chunks = 0